/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `tentative` - Tentative
 * * `confirmed` - Confirmed
 * * `completed` - Completed
 * * `settled` - Settled
 * * `cancelled` - Cancelled
 * @export
 */
export const Status02dEnum = {
    Tentative: 'tentative',
    Confirmed: 'confirmed',
    Completed: 'completed',
    Settled: 'settled',
    Cancelled: 'cancelled'
} as const;
export type Status02dEnum = typeof Status02dEnum[keyof typeof Status02dEnum];


export function instanceOfStatus02dEnum(value: any): boolean {
    for (const key in Status02dEnum) {
        if (Object.prototype.hasOwnProperty.call(Status02dEnum, key)) {
            if (Status02dEnum[key as keyof typeof Status02dEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function Status02dEnumFromJSON(json: any): Status02dEnum {
    return Status02dEnumFromJSONTyped(json, false);
}

export function Status02dEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): Status02dEnum {
    return json as Status02dEnum;
}

export function Status02dEnumToJSON(value?: Status02dEnum | null): any {
    return value as any;
}

export function Status02dEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): Status02dEnum {
    return value as Status02dEnum;
}

